/**
 * Dark/light toggle (navbar, beside search).
 *
 * The Ghost custom setting (Dark/Light/Auto) provides the default scheme via a
 * class on <html>. Clicking the toggle switches between explicit dark-mode and
 * light-mode and persists the choice in localStorage; default.hbs re-applies the
 * stored choice before first paint so there's no flash on page load.
 */
(function () {
    'use strict';

    var STORAGE_KEY = 'aho-color-scheme';
    var root = document.documentElement;
    var toggles = document.querySelectorAll('[data-theme-toggle]');
    if (!toggles.length) return;

    function isLight() {
        if (root.classList.contains('light-mode')) return true;
        if (root.classList.contains('auto-color')) {
            return window.matchMedia('(prefers-color-scheme: light)').matches;
        }
        return false;
    }

    function apply(mode) {
        root.classList.remove('light-mode', 'dark-mode', 'auto-color');
        root.classList.add(mode + '-mode');
    }

    toggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var next = isLight() ? 'dark' : 'light';
            apply(next);
            try {
                localStorage.setItem(STORAGE_KEY, next);
            } catch (e) { /* private browsing — toggle still works for this page */ }
        });
    });
})();
